import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";
import Swal from 'sweetalert2'

export default async function putContato(
  ContatoId: number, 
  contatoAtual: any,
  onSuccess: () => void,
) {
  
  return await api.put(`${URLS.CONTATO_API}/${ContatoId}`, contatoAtual)
  .then((response) => {
    Swal.fire({
      title: 'Sucesso',
      text: 'Contato editado com sucesso!',
      icon: 'success',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#349946',
      allowOutsideClick: false
    }).then(response => {
      if (response.isConfirmed) {
        onSuccess();
      }
    })
  })
  .catch((err) => {
    Swal.fire({
      title: 'Ocorreu um erro',
      text: err.response.data.message,
      icon: 'error',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#F27474',
      allowOutsideClick: false
    })
  })
}
